import React from 'react';
import classnames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';
import DaApp from '@wix/da-shared-react/pkg/DaApp';
import { getGlobalClassnamesForContext } from '@wix/da-react-context/pkg/helpers';
import SiteHeader, {
  Props as SiteHeaderProps,
} from '@wix/da-shared-react/pkg/SiteHeader';
import { ThemeOptions, ThemeSkin } from '@wix/da-react-context/pkg/ThemeContext';
import { submitModalRenderer } from '@wix/da-submit-shared/pkg/project-tools';

import s from './App.scss';

export type AppProps = SiteHeaderProps &
  WithTranslation & {
    isMobile: boolean;
    theme: ThemeOptions;
    themeSkin: ThemeSkin;
    features: string[];
  };

class App extends React.Component<AppProps & WithTranslation> {
  componentDidMount() {
    const { isMobile, theme, themeSkin, features } = this.props;
    document.body.classList.add(
      ...getGlobalClassnamesForContext({
        isMobile,
        theme,
        themeSkin,
      }).split(' ')
    );
    if (features.includes('complete_theme')) {
      document.body.classList.add('complete_theme');
    }
  }

  render() {
    const {
      t,
      isMobile,
      theme,
      themeSkin,
      features,
      ...headerProps
    } = this.props;
    return (
      <div
        className={classnames(
          s.root,
          features.includes('complete_theme') && 'complete_theme',
          getGlobalClassnamesForContext({ isMobile, theme, themeSkin })
        )}
      >
        <DaApp
          language="en"
          disableHeadTags={true}
          isLegacyHeader
          modalsRenderFunc={submitModalRenderer}
        >
          <SiteHeader {...headerProps} isLegacyHeader />
        </DaApp>
      </div>
    );
  }
}

export default withTranslation()(App);
